import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import { enter, leave } from 'el-transition'
import hotkeys from 'hotkeys-js'

export default class extends Controller {
  static targets = [
    'documentCheckbox',
    'menu',
    'menuContainer',
    'trigger',
  ]

  static values = {
    documentIds: Array,
    open: { default: false, type: Boolean },
  }

  connect() {
    useClickOutside(this, { element: this.menuTarget })

    hotkeys(
      'escape',
      { scope: this.element.id || 'clients--document-multiselect' },
      () => { this.hide() },
    )
  }

  addDocumentIds(event) {
    const searchParams =
      new URLSearchParams(event.target.href.split('?')[1] || '')
    searchParams.delete('document_ids[]')
    this.documentIdsValue.forEach((documentId) => {
      searchParams.append('document_ids[]', documentId)
    })
    event.target.href =
      `${event.target.href.split('?')[0]}?${searchParams.toString()}`
    this.openValue = false
  }

  clickOutside() {
    this.openValue = false
  }

  documentCheckboxTargetConnected(checkbox) {
    if (checkbox.checked) {
      this.documentIdsValue = this.documentIdsValue.concat([checkbox.value])
    }
  }

  documentCheckboxTargetDisconnected(checkbox) {
    this.documentIdsValue = this.documentIdsValue.filter(
      (documentId) => documentId !== checkbox.value,
    )
  }

  documentIdsValueChanged() {
    if (this.documentIdsValue.length === 0) {
      this.triggerTarget.disabled = true
    } else {
      this.triggerTarget.disabled = false
    }
  }

  toggleDocumentSelection(event) {
    const { checked } = event.target

    if (checked) {
      this.documentIdsValue = this.documentIdsValue.concat([event.target.value])
    } else {
      this.documentIdsValue = this.documentIdsValue.filter(
        (documentId) => documentId !== event.target.value,
      )
    }
  }

  toggleMenu() {
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.openValue) {
      this.#show()
    } else {
      this.#hide()
    }
  }

  #hide() {
    hotkeys.setScope('all')
    leave(this.menuContainerTarget)
  }

  #show() {
    hotkeys.setScope(this.element.id || 'clients--modal')
    enter(this.menuContainerTarget)
  }
}
